<template>
    <div class="contact-list-filters">
        <div class="filter-header">
            <div class="filter-title">{{ $t("message.filters") }}</div>
            <div class="material-icons close-icon" @click="$emit('close')">close</div>
        </div>
        <div class="filter-content">
            <div class="filter-item">
                <div class="filter-label" @click="toggleDropdown('date')">
                    Tarih
                    <div class="material-icons dropdown-icon">
                        {{ dropdowns.date ? "expand_less" : "expand_more" }}
                    </div>
                </div>
                <div v-if="dropdowns.date" class="filter-dropdown date-picker">
                    <a-select
                        v-model="cloneFilters.timeSelect"
                        @change="setCustomDateFilter(cloneFilters.timeSelect)"
                        class="select-date"
                    >
                        <a-select-option value="custom">{{ $t("time.custom") }}</a-select-option>
                        <a-select-option value="today">{{ $t("time.today") }}</a-select-option>
                        <a-select-option value="yesterday">{{ $t("time.yesterday") }}</a-select-option>
                        <a-select-option value="current-week">{{ $t("time.currentWeek") }}</a-select-option>
                        <a-select-option value="last-week">{{ $t("time.lastWeek") }}</a-select-option>
                        <a-select-option value="current-month">{{ $t("time.currentMonth") }}</a-select-option>
                        <a-select-option value="last-month">{{ $t("time.lastMonth") }}</a-select-option>
                        <a-select-option value="last-30">{{ $t("time.last30Day") }}</a-select-option>
                    </a-select>
                    <div class="custom-date-picker" v-if="cloneFilters.timeSelect === 'custom'">
                        <a-date-picker
                            v-model="cloneFilters.startDate"
                            :disabledDate="disabledStartDate"
                            show-time
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="Start"
                            @openChange="handleStartOpenChange"
                        />
                        <a-date-picker
                            v-model="cloneFilters.endDate"
                            :disabledDate="disabledEndDate"
                            show-time
                            format="YYYY-MM-DD HH:mm:ss"
                            placeholder="End"
                            :open="endDateOpened"
                            @openChange="handleEndOpenChange"
                        />
                    </div>
                </div>
            </div>
            <div class="filter-item">
                <div class="filter-label" @click="toggleDropdown('channels')">
                    {{ $t("message.allChannels") }}
                    <div class="material-icons dropdown-icon">
                        {{ dropdowns.channels ? "expand_less" : "expand_more" }}
                    </div>
                </div>
                <div v-if="dropdowns.channels" class="filter-dropdown">
                    <div class="search-wrapper">
                        <a-input v-model="searchQueries.channels" class="search-input" :bordered="false">
                            <template #prefix>
                                <div class="material-icons">search</div>
                            </template>
                        </a-input>
                    </div>
                    <div class="channel-group" @click="toggleDropdown('whatsapp')">
                        <WhatsappIcon class="channel-group-icon" color="#25D366" />
                        <span class="channel-label">WhatsApp</span>
                        <div class="material-icons dropdown-icon">
                            {{ dropdowns.whatsapp ? "expand_less" : "expand_more" }}
                        </div>
                    </div>
                    <div v-if="dropdowns.whatsapp" class="filter-dropdown">
                        <div class="checkbox-group">
                            <div
                                class="checkbox-item"
                                v-for="c in filteredWhatsappChannels"
                                :key="`channel-${c._id}-${isChecked('selectedChannelIds', c._id)}`"
                                @click="toggleCheckbox('selectedChannelIds', c._id)"
                            >
                                <span class="checkbox-item-label">{{ c.name }}</span>
                                <a-checkbox :checked="isChecked('selectedChannelIds', c._id)" />
                            </div>
                        </div>
                    </div>
                    <div class="channel-group" @click="toggleDropdown('messenger')">
                        <MessengerIcon class="channel-group-icon" color="#0088cc" />
                        <span class="channel-label">Messenger</span>
                        <div class="material-icons dropdown-icon">
                            {{ dropdowns.messenger ? "expand_less" : "expand_more" }}
                        </div>
                    </div>
                    <div v-if="dropdowns.messenger" class="filter-dropdown">
                        <div class="checkbox-group">
                            <div
                                class="checkbox-item"
                                v-for="c in filteredMessengerChannels"
                                :key="`channel-${c._id}-${isChecked('selectedChannelIds', c._id)}`"
                                @click="toggleCheckbox('selectedChannelIds', c._id)"
                            >
                                <span class="checkbox-item-label">{{ c.name }}</span>
                                <a-checkbox :checked="isChecked('selectedChannelIds', c._id)" />
                            </div>
                        </div>
                    </div>
                    <div class="channel-group" @click="toggleDropdown('instagram')">
                        <InstagramIcon class="channel-group-icon" special-background-mode />
                        <span class="channel-label">Instagram</span>
                        <div class="material-icons dropdown-icon">
                            {{ dropdowns.instagram ? "expand_less" : "expand_more" }}
                        </div>
                    </div>
                    <div v-if="dropdowns.instagram" class="filter-dropdown">
                        <div class="checkbox-group">
                            <div
                                class="checkbox-item"
                                v-for="c in filteredInstagramChannels"
                                :key="`channel-${c._id}-${isChecked('selectedChannelIds', c._id)}`"
                                @click="toggleCheckbox('selectedChannelIds', c._id)"
                            >
                                <span class="checkbox-item-label">{{ c.name }}</span>
                                <a-checkbox :checked="isChecked('selectedChannelIds', c._id)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="filter-item">
                <div class="filter-label" @click="toggleDropdown('departments')">
                    {{ $t("message.allDepartments") }}
                    <div class="material-icons dropdown-icon">
                        {{ dropdowns.departments ? "expand_less" : "expand_more" }}
                    </div>
                </div>
                <div v-if="dropdowns.departments" class="filter-dropdown">
                    <div class="search-wrapper">
                        <a-input v-model="searchQueries.departments" class="search-input" :bordered="false">
                            <template #prefix>
                                <div class="material-icons">search</div>
                            </template>
                        </a-input>
                    </div>
                    <div class="checkbox-group">
                        <div
                            class="checkbox-item"
                            v-for="d in filteredDepartments"
                            :key="`department-${d._id}-${isChecked('selectedDepartmentIds', d._id)}`"
                            @click="toggleCheckbox('selectedDepartmentIds', d._id)"
                        >
                            <span class="checkbox-item-label">{{ getDepartmentName(d) }}</span>
                            <a-checkbox :checked="isChecked('selectedDepartmentIds', d._id)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="filter-item">
                <div class="filter-label" @click="toggleDropdown('agents')">
                    Etkileşimdekiler
                    <div class="material-icons dropdown-icon">
                        {{ dropdowns.agents ? "expand_less" : "expand_more" }}
                    </div>
                </div>
                <div v-if="dropdowns.agents" class="filter-dropdown">
                    <div class="search-wrapper">
                        <a-input v-model="searchQueries.agents" class="search-input" :bordered="false">
                            <template #prefix>
                                <div class="material-icons">search</div>
                            </template>
                        </a-input>
                    </div>
                    <div class="checkbox-group">
                        <div
                            class="checkbox-item"
                            v-for="u in filteredUsers"
                            :key="`user-${u._id}-${isChecked('selectedUsers', u._id)}`"
                            @click="toggleCheckbox('selectedUsers', u._id)"
                        >
                            <AgentAvatar class="checkbox-item-agent" :size="20" :userID="u._id" :font-size="7" />
                            <span class="checkbox-item-label">{{ u.name }}</span>
                            <a-checkbox :checked="isChecked('selectedUsers', u._id)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SupsisButton @click="filter" primary>Uygula</SupsisButton>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import InstagramIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import MessengerIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import WhatsappIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import AgentAvatar from "../../common/AgentAvatar.vue";
import TimeUtils from "../../../utils/TimeUtils";
import moment from "moment";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "ContactListFilters",
    components: {
        SupsisButton,
        InstagramIcon,
        MessengerIcon,
        WhatsappIcon,
        AgentAvatar,
    },
    data: function () {
        return {
            cloneFilters: {},
            dropdowns: {
                date: true,
                channels: false,
                departments: false,
                agents: false,
                whatsapp: false,
                messenger: false,
                instagram: false,
            },
            searchQueries: {
                channels: "",
                departments: "",
                agents: "",
            },
            startDate: null,
            endDate: null,
            endDateOpened: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            departments: (state) => state.subject.subjects.data,
            instagramChannels: (state) => state.channel.channels.filter((x) => ["instagram"].includes(x.type)),
            messengerChannels: (state) => state.channel.channels.filter((x) => ["messenger"].includes(x.type)),
            whatsappChannels: (state) =>
                state.channel.channels.filter((x) =>
                    ["whatsapp-v1", "whatsapp-qr", "whatsapp-v2", "whatsapp-business-api"].includes(x.type)
                ),
            contactListFilters: (state) => state.chat.contactListFilters,
        }),
        filteredWhatsappChannels() {
            return this.whatsappChannels.filter((channel) =>
                channel.name.toLowerCase().includes(this.searchQueries.channels.toLowerCase())
            );
        },
        filteredMessengerChannels() {
            return this.messengerChannels.filter((channel) =>
                channel.name.toLowerCase().includes(this.searchQueries.channels.toLowerCase())
            );
        },
        filteredInstagramChannels() {
            return this.instagramChannels.filter((channel) =>
                channel.name.toLowerCase().includes(this.searchQueries.channels.toLowerCase())
            );
        },
        filteredDepartments() {
            return this.departments.filter((department) =>
                this.getDepartmentName(department).includes(this.searchQueries.departments.toLowerCase())
            );
        },
        filteredUsers() {
            return this.users.filter((user) =>
                user.name.toLowerCase().includes(this.searchQueries.agents.toLowerCase())
            );
        },
        disabledStartDate() {
            return (date) => {
                return (
                    date.valueOf() < moment(this.cloneFilters.endDate).subtract(1, "months").valueOf() ||
                    date.valueOf() < moment(this.cloneFilters.endDate).subtract(1, "days").valueOf() ||
                    date.valueOf() > moment().valueOf()
                );
            };
        },
        disabledEndDate() {
            return (date) => {
                if (!date || !this.cloneFilters.startDate) {
                    return false;
                }

                return (
                    date.valueOf() > moment(this.cloneFilters.startDate).add(1, "months").valueOf() ||
                    date.valueOf() > moment().valueOf() ||
                    date.valueOf() < moment(this.cloneFilters.startDate).valueOf()
                );
            };
        },
    },
    mounted() {
        this.cloneFilters = _.cloneDeep({
            ...this.contactListFilters,
            startDate: this.contactListFilters.startDate || moment().startOf("day").toISOString(),
            endDate: this.contactListFilters.endDate || moment().endOf("day").toISOString(),
        });
    },
    methods: {
        ...mapActions({
            updateContactFilters: "chat/updateContactFilters",
        }),
        filter() {
            log("ContactListFilters.filter() - updateContactFilters");
            this.updateContactFilters(this.cloneFilters);
            this.$emit("close");
        },
        handleStartOpenChange(open) {
            if (!open) this.endDateOpened = true;
        },
        handleEndOpenChange(open) {
            this.endDateOpened = open;
            if (!this.endDate) {
                this.endDate = moment(this.startDate).add(1, "month").toISOString();
            }
        },
        getLast11Months() {
            return TimeUtils.getLast11Months();
        },
        setCustomDateFilter(filter) {
            if (filter === "today") {
                this.cloneFilters.startDate = moment().startOf("day").toISOString();
                this.cloneFilters.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.cloneFilters.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.cloneFilters.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.cloneFilters.startDate = moment().startOf("week").startOf("day").toISOString();
                this.cloneFilters.endDate = moment().endOf("week").endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.cloneFilters.startDate = moment()
                    .startOf("isoWeeks")
                    .subtract(1, "days")
                    .startOf("isoWeeks")
                    .toISOString();
                this.cloneFilters.endDate = moment()
                    .startOf("isoWeeks")
                    .subtract(1, "days")
                    .endOf("isoWeeks")
                    .toISOString();
            } else if (filter === "current-month") {
                this.cloneFilters.startDate = moment().startOf("month").startOf("day").toISOString();
                this.cloneFilters.endDate = moment().endOf("month").endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.cloneFilters.startDate = moment()
                    .startOf("month")
                    .subtract(1, "days")
                    .startOf("month")
                    .toISOString();
                this.cloneFilters.endDate = moment().startOf("month").subtract(1, "days").endOf("month").toISOString();
            } else if (filter === "last-30") {
                this.cloneFilters.startDate = moment().subtract(30, "days").startOf("day").toISOString();
                this.cloneFilters.endDate = moment().endOf("day").toISOString();
            }
        },
        getDepartmentName(department) {
            return department.languageContent[this.$i18n.locale].name;
        },
        toggleDropdown(key) {
            this.dropdowns[key] = !this.dropdowns[key];
        },
        toggleCheckbox(key, value, e) {
            if (this.cloneFilters[key].includes(value)) {
                this.cloneFilters[key] = this.cloneFilters[key].filter((x) => x !== value);
            } else {
                this.cloneFilters[key].push(value);
            }
        },
        isChecked(key, value) {
            return this.cloneFilters[key].includes(value);
        },
    },
    watch: {
        contactListFilters: {
            deep: true,
            handler: _.debounce(function () {
                if (!this.$_.isEqual(this.cloneFilters, this.contactListFilters)) {
                    this.cloneFilters = _.cloneDeep(this.contactListFilters);
                }
            }, 100),
        },
    },
};
</script>

<style lang="scss">
.contact-list-filters {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    z-index: 10;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    max-height: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    &::-webkit-scrollbar {
        display: none;
    }

    .filter-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .filter-title {
            font-weight: bold;
            font-size: 16px;
        }

        .close-icon {
            cursor: pointer;
            font-size: 24px;
        }
    }

    .filter-content {
        border: 1px solid var(--color-border-default);
        padding: 10px;
        border-radius: 4px;
        width: 100%;

        .filter-item {
            margin-bottom: 10px;

            .filter-label {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: 600;
                margin-bottom: 5px;
                cursor: pointer;

                .dropdown-icon {
                    font-size: 24px;
                }
            }

            .filter-dropdown {
                width: 100%;
                transition: max-height 0.3s ease-in-out;
                overflow: hidden;

                &.date-picker {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }

                .select-date {
                    width: 100%;

                    .ant-select-selection {
                        background: var(--color-bg-neutral-default) !important;
                        border-color: var(--color-border-default) !important;
                    }
                }

                .custom-date-picker {
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    .ant-calendar-picker {
                        width: 100% !important;
                        min-width: inherit !important;
                    }
                }
            }

            .checkbox-group {
                display: flex;
                flex-direction: column;

                .checkbox-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    padding: 7px 20px;
                    align-items: center;
                    font-weight: 600;

                    &:hover {
                        background: var(--color-bg-neutral-default);
                    }

                    .checkbox-item-agent {
                        margin-right: 10px;

                        .offlineBorder {
                            border: 2px solid #aeaeae;
                        }

                        span {
                            font-size: 10px !important;
                        }
                    }

                    .checkbox-item-label {
                        width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        padding-right: 5px;
                    }

                    &:last-child {
                        margin-bottom: 10px;
                    }
                }
            }

            .search-wrapper {
                display: flex;
                align-items: center;
                background-color: #f1f4f7;
                border-radius: 6px;
                padding: 5px;
                margin-bottom: 10px;

                .search-input {
                    flex: 1;
                    border: none;
                    outline: none;
                    background: none;

                    .material-icons {
                        font-size: 20px;
                        color: #000;
                    }

                    input {
                        color: #000 !important;
                        font-weight: 500;
                        font-size: 13px;
                        background-color: transparent;

                        &:hover,
                        &:active,
                        &:focus {
                            box-shadow: none !important;
                        }
                    }
                }
            }

            .channel-group-icon {
                width: 25px;
                height: 25px;
                margin-right: 10px;
            }

            .channel-group {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                margin-left: 10px;
                cursor: pointer;

                .channel-label {
                    font-weight: bold;
                    margin-bottom: 5px;
                }

                .dropdown-icon {
                    margin-left: auto;
                }
            }
        }
    }
    .supsis-button {
        width: 100%;
        max-width: 100%;
    }
}
</style>
